export default "__VITE_ASSET__DM3AMv0O__"